export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/web-worker.4506a74c.worker.js");
}
